/* PTI course curriculum: on small screens, course buttons choose which course's
   curriculum column is shown. A custom element, so theme-editor section reloads
   do not stack listeners. Without JavaScript all columns stack. */
(() => {
  if (customElements.get('pti-course-curriculum')) return;

  class PtiCourseCurriculum extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.tabs = Array.from(this.querySelectorAll('[data-pti-course-tab]'));
      this.tabGroup = this.querySelector('[data-pti-course-tabs]');
      this.columns = Array.from(this.querySelectorAll('[data-pti-course-column]'));
      if (this.tabs.length < 2 || !this.tabGroup) return;

      this.active = this.tabs[0].dataset.ptiCourseTab;
      this.small = window.matchMedia('(max-width: 759px)');
      this.onBreakpoint = () => this.apply();
      this.small.addEventListener('change', this.onBreakpoint);
      this.tabs.forEach((tab) =>
        tab.addEventListener('click', () => {
          this.active = tab.dataset.ptiCourseTab;
          this.apply();
        })
      );

      this.tabGroup.hidden = false;
      this.apply();
    }

    disconnectedCallback() {
      if (this.small && this.onBreakpoint) this.small.removeEventListener('change', this.onBreakpoint);
    }

    apply() {
      const small = this.small.matches;
      this.tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.ptiCourseTab === this.active)));
      this.columns.forEach((column) => {
        column.hidden = small && column.dataset.ptiCourseColumn !== this.active;
      });
    }
  }

  customElements.define('pti-course-curriculum', PtiCourseCurriculum);
})();
